/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerFindAllTasksQueryResponse, ApplicationsControllerFindAllTasksPathParams, ApplicationsControllerFindAllTasksQueryParams, ApplicationsControllerFindAllTasks401, ApplicationsControllerFindAllTasks403, ApplicationsControllerFindAllTasks404 } from "../../models/checklistsController/ApplicationsControllerFindAllTasks";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { applicationsControllerFindAllTasks } from "../../clients/checklistsService/applicationsControllerFindAllTasks";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const applicationsControllerFindAllTasksQueryKey = (id: ApplicationsControllerFindAllTasksPathParams["id"], params: ApplicationsControllerFindAllTasksQueryParams = {}) => [{
  url: '/api/v1/checklist-applications/:id/tasks',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type ApplicationsControllerFindAllTasksQueryKey = ReturnType<typeof applicationsControllerFindAllTasksQueryKey>;
export function applicationsControllerFindAllTasksQueryOptions(id: ApplicationsControllerFindAllTasksPathParams["id"], params?: ApplicationsControllerFindAllTasksQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = applicationsControllerFindAllTasksQueryKey(id, params);
  return queryOptions<ApplicationsControllerFindAllTasksQueryResponse, ResponseErrorConfig<ApplicationsControllerFindAllTasks401 | ApplicationsControllerFindAllTasks403 | ApplicationsControllerFindAllTasks404>, ApplicationsControllerFindAllTasksQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return applicationsControllerFindAllTasks(id, params, config);
    }
  });
}

/**
 * @summary List tasks linked to a checklist application
 * {@link /api/v1/checklist-applications/:id/tasks}
 */
export function useApplicationsControllerFindAllTasks<TData = ApplicationsControllerFindAllTasksQueryResponse, TQueryData = ApplicationsControllerFindAllTasksQueryResponse, TQueryKey extends QueryKey = ApplicationsControllerFindAllTasksQueryKey>(id: ApplicationsControllerFindAllTasksPathParams["id"], params?: ApplicationsControllerFindAllTasksQueryParams, options: {
  query?: Partial<QueryObserverOptions<ApplicationsControllerFindAllTasksQueryResponse, ResponseErrorConfig<ApplicationsControllerFindAllTasks401 | ApplicationsControllerFindAllTasks403 | ApplicationsControllerFindAllTasks404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? applicationsControllerFindAllTasksQueryKey(id, params);
  const query = useQuery({
    ...applicationsControllerFindAllTasksQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ApplicationsControllerFindAllTasks401 | ApplicationsControllerFindAllTasks403 | ApplicationsControllerFindAllTasks404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}